/* eslint-disable import/first */
import React from 'react';

export default function CloseIcon(props) {
  return (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5 13.778L21.528 7.75L23.25 9.47195L17.222 15.5L23.25 21.528L21.528 23.25L15.5 17.222L9.47195 23.25L7.75 21.528L13.778 15.5L7.75 9.47195L9.47195 7.75L15.5 13.778Z"
        fill="white"
      />
    </svg>
  );
}
